import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import moment from 'moment';
import { get } from 'lodash';

import { StyledSmallSectionHeader } from 'containers/AUTODashboard/Body/MyContracts/styles';
import CustomCarousel from 'components/CustomCarousel';
import messages from 'containers/EpargnDashboard/Body/MyContracts/messages';
import { translate } from 'helpers/intl';
import { EpargneInfoCard } from 'components/ItemInfoCard';

const MyContracts = (props: {
  intl: IntlShape;
  contractsEpargn: any[];
  setDetailsPageBreadcrumbsPath: Function;
}) => {
  return (
    <>
      <StyledSmallSectionHeader>
        {translate({ ...messages.title }, props)}
      </StyledSmallSectionHeader>
      <CustomCarousel
        showIndicators={
          props.contractsEpargn && props.contractsEpargn.length > 1
        }
      >
        {props.contractsEpargn &&
          props.contractsEpargn.map((item, index) => (
            <EpargneInfoCard
              setDetailsPageBreadcrumbsPath={
                props.setDetailsPageBreadcrumbsPath
              }
              key={index}
              nameAssure={
                get(item.infoPolice, 'NOM_ASSURE') +
                ' ' +
                get(item.infoPolice, 'PRENOM_ASSURE')
              }
              status={'Actifs'}
              title={get(item, 'infoPolice.LIBELLE_PRODUIT')}
              dateValue={moment(
                get(item, 'infoPolice.DATE_EFFET'),
                'YYYY-MM-DD',
              ).format('DD/MM/YYYY')}
              numValue={get(item, 'infoPolice.NUMERO_POLICE')}
              wrapperPaddingRight={
                index === props.contractsEpargn.length - 1 ? '24px' : '45px'
              }
              wrapperPaddingLeft={index === 0 ? '24px' : '45px'}
            />
          ))}
      </CustomCarousel>
    </>
  );
};

export default injectIntl(MyContracts);
